module.exports = __webpack_public_path__ + "img/vr-bg.52b556da.png";